// extracted by mini-css-extract-plugin
module.exports = {"root":"HardwareNode_root__2cDTf","title":"HardwareNode_title__29-T4"};